<ndt-prompt-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [showExtensionRegisterPopup]="showExtensionRegisterPopup$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [promptPrivileges]="promptPrivileges$ | async"
   [includeInactivePromptsControl]="true"
   (create)="onCreate()"
   [name]="entityName"
   [columns]="columns"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
>
</ndt-prompt-register-view>
